import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  // Public
  public apiData = [];
  public onApiDataChange: BehaviorSubject<any>;

  /**
   *
   * @param {HttpClient} _httpClient
   */
  constructor(private _httpClient: HttpClient) {
    this.onApiDataChange = new BehaviorSubject('');
    this.getNotificationsData();
  }

  /**
   * Get Notifications Data
   */
  getNotificationsData(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${environment.apiUrl}backoffice-parceiro/notifications`).subscribe((response: any) => {
        this.apiData = response;
        this.onApiDataChange.next(this.apiData);
        resolve(this.apiData);
      }, reject);
    });
  }

  /**
   * Mark individual notification as read
   * @param notificationId - ID of the notification to mark as read
   */
  markNotificationAsRead(notificationId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${environment.apiUrl}backoffice-parceiro/notifications/${notificationId}/read`, {}).subscribe((response: any) => {
        resolve(response);
      }, reject);
    });
  }

  /**
   * Mark all notifications as read
   */
  markAllNotificationsAsRead(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${environment.apiUrl}backoffice-parceiro/notifications/read-all`, {}).subscribe((response: any) => {
        resolve(response);
      }, reject);
    });
  }
}
